import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserQuery } from 'src/app/auth/state/user.query';
import { SnackbarService } from '../services/snackbar.service';

/**
 * Blocks routes that require an active organization. Users with no `orgId`
 * and no `orgIds` are redirected to `/app/profile` so they can view/cancel
 * pending join requests without being dumped back to the login wall.
 */
export const orgRequiredGuard: CanActivateFn = () => {
  const userQuery = inject(UserQuery);
  const snackbar = inject(SnackbarService);
  const router = inject(Router);

  const user = userQuery.getCurrentUser();
  const hasOrg = !!user?.orgId || (user?.orgIds?.length ?? 0) > 0;
  if (hasOrg) {
    return true;
  }

  snackbar.tInfo('core.organizationRequired');
  return router.parseUrl('/app/profile');
};
